import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Controller from '@ember/controller';

export default class NewController extends Controller {
  @service masq;
  @service alerts;
  @service router;

  serverErrors = null;
  canFinish = false;

  @action
  setupTwoFactorAuthentication(code) {
    return this.get('model.user')
      .setupTwoFactorAuthentication({ code, secret: this.get('model.secret') })
      .then(() => {
        this.router.transitionTo('settings.personal.security.new_backup_codes');
      })
      .catch((err) => {
        if (err.errors?.[0]?.status === '400') {
          return this.set('serverErrors', ['Your authentication code is invalid. Try again?']);
        }
        throw err;
      });
  }

  @action
  resetServerErrors() {
    this.set('serverErrors', []);
  }

  @action
  next() {
    return this.router.transitionTo('settings.personal.security.new_totp');
  }
}
